<template>
  <b-container fluid>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small hover
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="molliePayments"
          :fields="fields"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
        >
          <template v-slot:row-details="row">
            <b-card border-variant="info">
              <b-row>
                <b-col>
                  <b-table small :items="row.item.audits">
                    <template v-slot:cell(action)="audit">
                      <div v-b-tooltip.hover :title="descriptionForAction(audit.item.action)">
                        {{ "*" + audit.item.action }}
                      </div>
                    </template>
                  </b-table>
                </b-col>
                <b-col cols="3">
                  <b-btn 
                    size="sm"
                    class="m-2"
                    v-if="getUserBrandPermissions.super_admin && row.item.mollie_payment_id != null"
                    @click="openMolliePayment(row.item.mollie_payment_id)"
                  >
                    MolliePayment
                  </b-btn>
                  <b-btn
                    class="m-2"
                    variant="info"
                    size="sm"
                    @click="$router.push({ name: 'customer', params: { id: row.item.customer.id } })"
                  >
                    {{ row.item.customer.company_name }}
                  </b-btn>
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template v-slot:cell(created_at)="item">
            <div v-b-tooltip.hover :title="item.item.created_at">
              {{ item.item.created_at.substring(0, 10) }}
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="molliePayments.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      molliePayments: [],
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        "id",
        {
          key: "customer.company_name",
          label: this.$t("globals.customer"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "payment_method",
          label: this.$t("globals.payment_method"),
          sortable: true
        },
        {
          key: "invoice_type",
          label: this.$t("globals.invoice_type"),
          sortable: true
        },
        {
          key: "invoice_no",
          label: this.$t("globals.invoice_no"),
          sortable: true
        },

        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch"]),
    currencyFormat,
    onFiltered() {
      this.currentPage = 1;
    },
    rowClicked(item) {
      item._showDetails = !item._showDetails;
      this.molliePayments.forEach(payment => {
        if (item.id != payment.id) {
          payment._showDetails = false;
        }
      });
    },
    fetchMolliePayments() {
      let data = {
        query: `
          query {
            allMolliePayments {
              id
              mollie_payment_id
              status
              payment_method
              invoice_type
              invoice_no
              invoice_id
              created_at
              _showDetails
              _rowVariant
              customer {
                id
                company_name
              }
              audits {
                action
                created_at
              }
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.molliePayments = res.allMolliePayments;
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    },
    openMolliePayment(mollie_payment_id) {
      window.open(
        `https://www.mollie.com/dashboard/org_7462221/payments/${mollie_payment_id}`,
        "_blank"
      );
    },
    descriptionForAction(action) {
      let desc = "";
      switch (action) {
        case "created":
          desc = "The payment was created locally"
          break;
        case "open":
          desc = "The payment was created on Mollie and is awaiting actions"
          break;
        case "paid":
          desc = "The payment was paid"
          break;
        case "canceled":
          desc = "The payment was canceled by the customer"
          break;
        case "expired":
          desc = "The customer didnt set up mollie in time"
          break;
      }
      return desc
    }
  },
  computed: {
    ...mapGetters(["getBackendUrl", "getLocale", "getUserBrandPermissions"])
  },
  mounted() {
    this.fetchMolliePayments();
  }
};
</script>
